import { getCurrentScope } from '@sentry/solidstart';
import { mount, StartClient } from '@solidjs/start/client';
import { createApiClient } from '@troon/api-client';
import { ErrorBoundary } from 'solid-js';
import { AnalyticsProvider } from '@troon/analytics';
import { createClient } from '@troon/analytics/client';

let sessionId = '';
try {
	sessionId = window.crypto?.randomUUID?.();
} catch {
	// no-op
}

createApiClient({
	baseUrl: window.__CONFIG__.apiBaseUrl,
	localStorageToken: 'tga',
	platform: 'embed',
	version: window.__CONFIG__.sha,
	sessionId,
}).use({
	async onRequest({ request }) {
		const scope = getCurrentScope();
		scope.setExtras(Object.fromEntries(request.headers));
		return request;
	},
});

const posthog = createClient({
	key: window.__CONFIG__.phKey,
	api_host: `https://${window.__CONFIG__.phHost}/_/ingest`,
	bootstrap: {
		isIdentifiedID: false,
	},
	before_send: (result) => {
		if (!window.__CONFIG__.phEnabled) {
			return null;
		}
		const path = window.location.pathname.split('/');
		const idx = path.findIndex((part) => part === 'embed');
		const embedSlug = path[idx + 1];
		if (result && embedSlug) {
			result.properties.embed = embedSlug;
		}
		return result;
	},
});

mount(() => {
	return (
		<ErrorBoundary fallback={(error) => <div>{error}</div>}>
			<AnalyticsProvider posthog={posthog} gtmId={window.__CONFIG__.gtmId} cookieYesId={window.__CONFIG__.cookieYesId}>
				<StartClient />
			</AnalyticsProvider>
		</ErrorBoundary>
	);
}, document.getElementById('app')!);
